import {
  EWorkZonesManagementRights,
} from "mhc-server/dist/interfaces";

import {IAppRoute} from "../../application/config/IAppRoute";
import {MapsPrepareForOfflineUse} from "../pages/MapsPrepareForOfflineUse/MapsPrepareForOfflineUse";
import SaveMapsIcon from "@mui/icons-material/Map";

export const routeSaveOfflineMaps: IAppRoute = {
  title: 'Save Offline Maps',
  icon: <SaveMapsIcon/>,
  routePath: '/cimt/save-offline-maps',
  getRoutePath: () => routeSaveOfflineMaps.routePath,
  menuId: 'save-offline-maps',
  userHasAllRights: [EWorkZonesManagementRights.WORKZONES_EDIT],
  userHasAnyOfRights: [],
  render: () => <MapsPrepareForOfflineUse/>,
};
